define(
	'actions/rsvp-summaries',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes"
	],
	function($,_,Backbone,React,AppDispatcher,Constants){
		return Backbone.Model.extend({
			init: function(params) {
			},
			addRSVPs: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.ADD_RSVP_SUMMARY,
					data: params
				});
			},
			updateRSVPSummary: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.REFRESH_RSVP_SUMMARY,
					data: params
				});
			},
			pull: function(guid) {
				var self = this;
				var rsvps = [];

				if(guid) {
					window.api.request("rsvps", "summary", guid).execute().done(function(response) {
						self.addRSVPs(response.rsvp);
					});
				}
				else {
					window.api.request("rsvps", "summary").each(function iterator (index, item) {
						rsvps.push(item);
					}, function () {
						self.addRSVPs(rsvps);
					});
				}
			},
			refresh: function(guid) {
				var self = this;

				window.api.request("rsvps", "summary", guid).execute().done(function(response) {
					self.updateRSVPSummary(response.data);
				});
			}
		});
	}
);
